export default __webpack_public_path__ + "static/media/breach2.57b76745.png";